<template>
  <div id="summaryIndex" class="summaryIndex">
    <div class="list-bj">
      <div class="list-item black" @click="clkxShow('Summary')">
        <i :class="{ 'el-icon-arrow-down': !summaryShow, 'el-icon-arrow-up': summaryShow}" /> <span
          class="item-name"
        >下单信息</span>
      </div>
      <div v-if="summaryShow" class="list-card">
        <Summary ref="Summary" />
      </div>
    </div>
    <div class="list-bj">
      <div class="list-item black" @click="clkxShow('Cargo')">
        <i :class="{ 'el-icon-arrow-down': !cargoShow, 'el-icon-arrow-up': cargoShow}" /> <span
          class="item-name"
        >商品信息</span>
      </div>
      <div v-if="cargoShow" class="file-table">
        <table class="table">
          <tr>
            <td>箱号</td>
            <td>品名</td>
            <td>海关编码</td>
            <td>数量</td>
            <td>申报价值</td>
            <td>材质</td>
            <td>用途</td>
            <td>FBANO</td>
            <td>ReID</td>
          </tr>
          <tr v-for="(item,index) in cargoList" :key="index">

            <td>{{ item.cartonNo }}</td>
            <td>{{ item.nameCh }}</td>
            <td>{{ item.customlabel }}</td>
            <td>
              {{ item.quantity }}
            </td>
            <td>单价{{ item.unitPrice }}USD|合计{{ item.totalPrice }}USD
            </td>
            <td>
              {{ item.material }}
            </td>
            <td>
              {{ item.purpose }}
            </td>
            <td>
              {{ item.fbaNo }}
            </td>
            <td>
              {{ item.reId }}
            </td>
          </tr>
        </table>

      </div>
    </div>
    <div class="list-bj">
      <div class="list-item black" @click="clkxShow('Volume')">
        <i :class="{ 'el-icon-arrow-down': !volumeShow, 'el-icon-arrow-up': volumeShow}" /> <span
          class="item-name"
        >材积信息</span>
      </div>
      <div v-if="volumeShow" class="file-table">
        <table v-if="volume.margeList&&volume.margeList.length>0" class="table">
          <tr>
            <td>箱号</td>
            <td>预报-长x宽x高(CM) | 实量(KG)</td>
            <td>预报件数</td>
            <td>收货-长x宽x高(CM) | 实量(KG)</td>
            <td>收货件数</td>
            <td>围长(CM)</td>
            <td>子单号</td>
          </tr>
          <tr v-for="(item,index) in volume.margeList" :key="index">

            <td>{{ item.cartonNo }}</td>
            <td>{{ item.length }}x{{ item.width }}x{{ item.height }} | {{ item.weight }}</td>
            <td>{{ item.quantity }}</td>

            <td>{{ item.receiveLength }}x{{ item.recevieWidth }}x{{ item.recevieHeight }} | {{ item.receiveWeight }}</td>
            <td>
              {{ item.recevieQuantity }}
            </td>
            <td>
              {{ item.girth }}
            </td>
            <td>
              {{ item.subTrackNo }}
            </td>
          </tr>
        </table>
        <div v-else>
          <table v-if="volume.customerList&&volume.customerList.length>0" class="table">
            <tr>
              <td>箱号</td>
              <td>预报-长x宽x高(CM) | 实量(KG)</td>
              <td>预报件数</td>
              <td>围长(CM)</td>
              <td>子单号</td>
            </tr>
            <tr v-for="(item,index) in volume.customerList" :key="index">
              <td>{{ item.cartonNo }}</td>
              <td>{{ item.length }}x{{ item.width }}x{{ item.height }} | {{ item.weight }}</td>
              <td>{{ item.quantity }}</td>
              <td>
                {{ item.girth }}
              </td>
              <td>
                {{ item.subTrackNo }}
              </td>
            </tr>
          </table>
          <table v-if="volume.receiveList&&volume.receiveList.length>0" class="table">
            <tr>
              <td>箱号</td>
              <td>收货-长x宽x高(CM) | 实量(KG)</td>
              <td>收货件数</td>
              <td>围长(CM)</td>
              <td>子单号</td>
            </tr>
            <tr v-for="(item,index) in volume.receiveList" :key="index">
              <td>{{ item.cartonNo }}</td>
              <td>{{ item.length }}x{{ item.width }}x{{ item.height }} | {{ item.weight }}</td>
              <td>{{ item.quantity }}</td>
              <td>
                {{ item.girth }}
              </td>
              <td>
                {{ item.subTrackNo }}
              </td>
            </tr>
          </table>
        </div>

      </div>
    </div>
    <div class="list-bj">
      <div class="list-item black" @click="clkxShow('Documents')">
        <i :class="{ 'el-icon-arrow-down': !documentsShow, 'el-icon-arrow-up': documentsShow}" /> <span
          class="item-name"
        >订单附件</span>
      </div>
      <div v-if="documentsShow" class="list-card">
        <Documents ref="Documents" />
      </div>
    </div>

    <div class="list-bj">
      <div class="list-item black" @click="clkxShow('Contacts')">
        <i :class="{ 'el-icon-arrow-down': !contactsShow, 'el-icon-arrow-up': contactsShow}" /> <span
          class="item-name"
        >订单联系人</span>
      </div>
      <div v-if="contactsShow" class="list-card">
        <Contacts ref="Contacts" />
      </div>
    </div>
  </div>
</template>

<script>
import Summary from './Summary.vue'
import Documents from './documents.vue'
import Contacts from './Contacts.vue'
import TransitInfo from './TransitInfo.vue'
import request from '@/utils/request'
import {
  getCookie
} from '@/utils/cookiejs'
export default {
  name: 'SummaryIndex',
  components: {
    // 组件的引用
    Summary,
    Documents,
    TransitInfo,
    Contacts
  },
  props: {
    // 父辈向子辈传参
  },
  data() {
    return {
      token: '',
      list: [{
        name: 'Transit Information',
        isTrue: false,
        type: 'TransitInfo',
        disaled: true
      },
      {
        name: 'Documents',
        isTrue: false,
        type: 'Documents',
        disaled: true
      },
      {
        name: 'Summary',
        isTrue: true,
        type: 'Summary',
        disaled: false
      },
      {
        name: 'Consignor And Consignee',
        isTrue: false,
        type: 'Contacts',
        disaled: true
      }
      ],
      data: {},
      selectList: [],
      transitInfoEabled: false,
      documentsEabled: false,
      contactsEabled: false,
      transitShow: false,
      documentsShow: false,
      contactsShow: false,
      summaryShow: true,
      cargoShow: false,
      volumeShow: true,
      cargoList: [],
      volume: {}
    }
  },
  computed: {
    // 计算属性
  },
  watch: {
    // 监测变化
  },
  created() {
    this.token = getCookie('token')
  },
  mounted() {
    // 页面进入时加载内容
  },
  methods: {
    init(data) {
      this.data = data
      if (data.status > 1 && data.status < 7) {
        this.transitInfoEabled = true
        this.documentsEabled = true
        this.contactsEabled = true
      } else {
        this.transitInfoEabled = false
        this.documentsEabled = false
        this.contactsEabled = false
      }
      this.$nextTick(() => {
        this.$refs.Summary.init(data)
      })
      this.getCargoList()
      this.getVolumeList()
    },
    getCargoList() {
      request({
        url: `/api/wms/operate/order/getcargo/${this.data.orderNo}`,
        method: 'GET',
        headers: {
          Authorization: this.token
        }
      }).then((res) => {
        this.cargoList = res.data
      })
    },
    getVolumeList() {
      request({
        url: `/api/webapi/order/GetVolumeList/${this.data.orderNo}`,
        method: 'GET',
        headers: {
          Authorization: this.token
        }
      }).then((res) => {
        this.volume = res.data
      })
    },
    clkxShow(type) {
      switch (type) {
        case 'TransitInfo':
          if (this.transitInfoEabled) {
            this.transitShow = !this.transitShow
            if (this.transitShow) {
              this.$nextTick(() => {
                this.$refs.TransitInfo.init(this.data)
              })
            }
          }
          break
        case 'Documents':
          if (this.transitInfoEabled) {
            this.documentsShow = !this.documentsShow
            if (this.documentsShow) {
              this.$nextTick(() => {
                this.$refs.Documents.init(this.data)
              })
            }
          }
          break
        case 'Summary':
          if (this.transitInfoEabled) {
            this.summaryShow = !this.summaryShow
            if (this.summaryShow) {
              this.$nextTick(() => {
                this.$refs.Summary.init(this.data)
              })
            }
          }
          break
        case 'Contacts':
          if (this.transitInfoEabled) {
            this.contactsShow = !this.contactsShow
            if (this.contactsShow) {
              this.$nextTick(() => {
                this.$refs.Contacts.init(this.data)
              })
            }
          }
          break
        case 'Cargo':
          this.cargoShow = !this.cargoShow
          break
        case 'Volume':
          this.volumeShow = !this.volumeShow
          break
      }
    }
  }
}
</script>
<style scoped lang='scss'>
	.summaryIndex {
		width: 1200px;
		height: auto;
		background: #FFFFFF;
		border-radius: 8px;
		margin-top: 16px;

		.list-bj {
			.list-item {
				cursor: pointer;
				text-align: left;
				height: 48px;
				line-height: 48px;
				padding-left: 8px;
				display: flex;
				align-items: center;

				.red-tip {
					display: flex;
					align-items: center;
					justify-content: center;
					width: 156px;
					height: 24px;
					background: rgba(239, 10, 10, 0.04);
					border-radius: 12px;
					margin-left: 16px;

					span {
						font-family: PingFangSC, PingFang SC;
						font-weight: 400;
						font-size: 12px;
						color: #EF0A0A;
						margin-left: 4px;
					}
				}

				.item-name {
					font-size: 14px;
					font-family: PingFangSC, PingFang SC;
					font-weight: 500;
					color: #AAAAAA;
				}
			}
		}

		.file-table {
			text-align: center;

			.table {
				border: 1px solid rgba(221, 221, 221, 0.56);
				border-radius: 8px;
				width: 90%;
				border-collapse: collapse;
				margin-left: 5%;
				padding: 0 8px;

				tr:nth-of-type(1) {
					td {
						font-size: 14px;
						font-family: PingFangSC, PingFang SC;
						font-weight: 400;
						color: #777777;
						background: rgba(221, 221, 221, 0.24);
						width: 200px;
					}
				}

				tr {
					height: 40px;

					td {
						padding-left: 8px;
						font-size: 14px;
						font-family: PingFangSC, PingFang SC;
						font-weight: 400;
						color: #333333;
						width: 200px;

						.division-line {
							display: inline-block;
							height: 20px;
							width: 100%;
							border-right: 1px solid #DDDDDD;
						}

						.blue {
							color: #027FFC;
							cursor: pointer;
						}
					}
				}
			}
		}

	}
</style>
